import { BaseCardProps } from '~/components/Card';
import { Translation } from '~/components/I18n/Translation';
import calendar from '~/components/Icon/blankCalendar.png';
import info from '~/components/Icon/info.png';
import bag from '~/components/Icon/shoppingBag.png';
import wallet from '~/components/Icon/wallet.png';
import user from '~/components/Icon/whiteUser.png';

export type CategoryAdditionalInfoValue = {
  color: BaseCardProps['color'] | 'yellow' | 'orange' | 'green' | 'blue' | 'deep-blue';
  description: React.ReactNode;
  figure: 'image';
};

export const categoryAdditionalInfo: Record<string, CategoryAdditionalInfoValue> = {
  General: {
    color: 'yellow',
    description: <Translation name="citizen_help_cat_desc1" />,
    figure: info,
  },
  Membership: {
    color: 'orange',
    description: <Translation name="citizen_help_cat_desc2" />,
    figure: user,
  },
  Purchases: {
    color: 'blue',
    description: <Translation name="citizen_help_cat_desc4" />,
    figure: bag,
  },
  Payments: {
    color: 'green',
    description: <Translation name="citizen_help_cat_desc5" />,
    figure: wallet,
  },
  Others: {
    color: 'deep-blue',
    description: <Translation name="citizen_help_cat_desc3" />,
    figure: calendar,
  },
};
